import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const ITEMS = [
  { key: "daily_importer", label: "Digital Daily Importer" },
  { key: "dcy01208_digital", label: "DCY 01208 Digital" },
];

export const RecordsAccessToggles = ({ center }) => {
  const [features, setFeatures] = useState(center.records_features || { daily_importer: true, dcy01208_digital: true });

  const toggle = async (key, on) => {
    const prev = features;
    setFeatures({ ...features, [key]: on });
    try {
      const r = await api.put(`/superadmin/centers/${center.id}/records-access`, { [key]: on });
      setFeatures(r.data.records_features);
      toast.success(`${ITEMS.find((i) => i.key === key).label} ${on ? "shown" : "hidden"} for ${center.name}.`);
    } catch (err) {
      setFeatures(prev);
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="mt-2 flex flex-wrap items-center gap-3" data-testid={`sa-records-access-${center.id}`}>
      <span className="text-[10px] uppercase tracking-widest font-semibold text-stone-400">Records</span>
      {ITEMS.map((i) => (
        <label key={i.key} className="inline-flex items-center gap-1.5 text-[11px] text-stone-600 cursor-pointer">
          <Switch
            data-testid={`sa-records-${i.key}-${center.id}`}
            checked={!!features[i.key]}
            onCheckedChange={(v) => toggle(i.key, v)}
            className="scale-75"
          />
          {i.label}
        </label>
      ))}
    </div>
  );
};
